defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/PurchaseFlow/FreeDeposit',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Utils',
    'DanskeSpil/Framework/NumberGames/Scripts/Helpers/Utils',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Loader',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Card/CardContent',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton'
  ],
  function (m, Utils, NumberGamesUtils, Loader, CardContent, CtaButton) {
    var FreeDeposit = {
      controller: function ({ controller }) {
        Object.assign(this, controller);
        this.loading = m.prop(true);
        this.gameClient = m.prop(null);

        if (!this.play()) {
          this.error(this.rootDictionary.get('ErrorMessages/GENERIC_ERROR'));
          return;
        }

        this.pageTitle(this.dictionary('DepositTypeFree/PageTitle'));
        this.pageDescription(controller.dictionary('DepositTypeFree/PageDescription' + this.multiWagerSuffix(), { WEEKS: this.play().numberOfDraws, DRAWS: controller.play().numberOfDraws }));

        const playType = NumberGamesUtils.formatNaming(this.playType, 'capitalized');
        const gameTypePathName = NumberGamesUtils.formatNaming(this.gameType(), 'capitalized');
        const gameClientFileName = `${gameTypePathName}${playType}Client`;

        requireDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Game/' + gameClientFileName, (Client) => {
          this.property('animate', '');
          this.property('dictionary', this.dictionary);
          this.property('numberOfDraws', this.play().numberOfDraws);
          this.property('clubId', this.property('clubPageController').clubId());
          this.property('playId', this.playId());
          this.property('depositType', this.depositType);
          this.property('afterGameModelLoaded', () => {
            this.game(this.property('gameModel')());
            this.useCampaignEngineInit();
          });

          Client(m, this.settings, this.property).then((client) => {
            this.gameClient(client);
            this.loading(false);

            m.redraw();
          }, (error) => {
            this.error(error);
            this.loading(false);

            m.redraw();
          });
        });
      },
      view: function (controller) {
        const $content = () => {
          if (controller.loading()) {
            return Loader(controller);
          }

          return m('.play-together-game-selector-wrapper', [
            controller.gameClient(),
            controller.property('specialCampaignTicketCounter')?.({ rows: controller.game()?.rowsToGenerate() })
          ]);
        };

        const $footer = () => {
          if (controller.loading() || !controller.property('gameModel')) {
            return;
          }
          return CtaButton({
            className: 'yellow big',
            text: controller.subscriptionGroupGameId() ? controller.rootDictionary.get('ChooseWeeks/GoToPlayAsSubscriptionButton') : controller.dictionary('BuyInButton', { price: Utils.formatCurrency(controller.property('gameModel')().totalPrice()) }),
            onClick: controller.action,
            loading: controller.processing()
          });
        };

        const className = () => {
          let name = '';

          if (controller.useCampaignFlowGraphics() &&
            controller.drawsInCampaignCount()) {
            name = 'campaign-theming';
          }

          return name;
        };

        return CardContent({
          className: className(),
          $content: $content(),
          $footer: $footer()
        });
      }
    };

    // Public functions:
    return FreeDeposit;
  });
